import { ndcAllowedRoles } from 'data/facts/userRolesValidations';
import {
  FutureNdcStrategyDates,
  NDCFormFields,
  NDCFormFieldsTypes,
} from 'Interfaces/FactsInterfaces/drugInterfaces';
import { ndcHistoryDataInterface } from 'Interfaces/FactsInterfaces/ndcInterfaces';
import { moduleTypes, roleInstance } from 'Interfaces/roleBasedAccessInterfaces';

export const handleCheckErrorForNdcIndividualEdit = ({
  ndcStrategyIndividualEditData,
  initialNdcStrategyIndividualEditData,
  setErrorDetails,
  futureNdcData,
}: {
  ndcStrategyIndividualEditData: NDCFormFields;
  initialNdcStrategyIndividualEditData: NDCFormFields;
  setErrorDetails: (error: { isError: boolean; errorDetails: string }) => void;
  futureNdcData: ndcHistoryDataInterface;
}) => {
  if (ndcStrategyIndividualEditData && initialNdcStrategyIndividualEditData) {
    let errorFound = false;
    const fields: NDCFormFieldsTypes[] = ['PPS', 'PPSSC', 'Segmentation', 'DPStrategy'];

    // fields.forEach((field) => {
    for (let i = 0; i < fields.length; i++) {
      // check if something is left empty
      const field = fields[i];
      if (
        !ndcStrategyIndividualEditData[field].value &&
        (ndcStrategyIndividualEditData[field].startDate ||
          ndcStrategyIndividualEditData[field].endDate)
      ) {
        setErrorDetails({
          isError: true,
          errorDetails: `Value, start and end date can't be left empty for ${
            field === 'PPSSC' ? 'PPS reason' : field
          }`,
        });
        errorFound = true;
        break;
      }
      if (
        !ndcStrategyIndividualEditData[field].value &&
        (ndcStrategyIndividualEditData[field].startDate ||
          ndcStrategyIndividualEditData[field].endDate)
      ) {
        setErrorDetails({
          isError: true,
          errorDetails: `Please select value for ${field === 'PPSSC' ? 'PPS reason' : field}`,
        });
        errorFound = true;
        break;
      }

      if (
        ndcStrategyIndividualEditData[field].value &&
        !ndcStrategyIndividualEditData[field].startDate &&
        !ndcStrategyIndividualEditData[field].endDate
      ) {
        setErrorDetails({
          isError: true,
          errorDetails: `Start and end dates can't be left empty for ${
            field === 'PPSSC' ? 'PPS reason' : field
          } `,
        });
        errorFound = true;
        break;
      }

      if (
        ndcStrategyIndividualEditData[field].value &&
        !ndcStrategyIndividualEditData[field].startDate
      ) {
        setErrorDetails({
          isError: true,
          errorDetails: `Start date can't be left empty for ${
            field === 'PPSSC' ? 'PPS reason' : field
          } `,
        });
        errorFound = true;
        break;
      }

      if (
        ndcStrategyIndividualEditData[field].value &&
        !ndcStrategyIndividualEditData[field].endDate
      ) {
        setErrorDetails({
          isError: true,
          errorDetails: `End date can't be left empty for ${
            field === 'PPSSC' ? 'PPS reason' : field
          } `,
        });
        errorFound = true;
        break;
      }

      // checks if value is changed, dates should change
      if (
        ndcStrategyIndividualEditData[field].value !==
          initialNdcStrategyIndividualEditData[field].value &&
        ndcStrategyIndividualEditData[field].startDate ===
          initialNdcStrategyIndividualEditData[field].startDate
      ) {
        setErrorDetails({
          isError: true,
          errorDetails: `Value is changed for ${
            field === 'PPSSC' ? 'PPS reason' : field
          }, but start is not changed, please change both`,
        });
        errorFound = true;
        break;
      }

      if (
        ndcStrategyIndividualEditData[field].startDate &&
        ndcStrategyIndividualEditData[field].endDate &&
        new Date(ndcStrategyIndividualEditData[field].startDate) >=
          new Date(ndcStrategyIndividualEditData[field].endDate)
      ) {
        setErrorDetails({
          isError: true,
          errorDetails: `Start should be lesser than End date for ${
            field === 'PPSSC' ? 'PPS reason' : field
          }`,
        });
        errorFound = true;
        break;
      }

      // check if the date range overlaps with future date ranges
      const tempDateRange: FutureNdcStrategyDates[] = [];

      if (field === 'PPS') {
        futureNdcData.PPS_History.future.forEach(instance => {
          tempDateRange.push({
            StartDate: instance.StartDate,
            EndDate: instance.EndDate,
            NDC11: instance.NDC11,
          });
        });
      } else if (field === 'PPSSC') {
        futureNdcData.PPS_Reason_History.future.forEach(instance => {
          tempDateRange.push({
            StartDate: instance.StartDate,
            EndDate: instance.EndDate,
            NDC11: instance.NDC11,
          });
        });
      } else if (field === 'Segmentation') {
        futureNdcData.Segmentation.future.forEach(instance => {
          tempDateRange.push({
            StartDate: instance.StartDate,
            EndDate: instance.EndDate,
            NDC11: instance.NDC11,
          });
        });
      } else if (field === 'DPStrategy') {
        futureNdcData.dp_strategy.future.forEach(instance => {
          tempDateRange.push({
            StartDate: instance.StartDate,
            EndDate: instance.EndDate,
            NDC11: instance.NDC11,
          });
        });
      }

      if (
        checkFutureStrategiesOverlapForNdcEdit(
          ndcStrategyIndividualEditData[field].startDate,
          ndcStrategyIndividualEditData[field].endDate,
          tempDateRange
        ).overlapFound
      ) {
        setErrorDetails({
          isError: true,
          errorDetails: `Given date range can't be set because it overlaps with future strategy for ${
            field === 'PPSSC' ? 'PPS reason' : field
          } `,
        });
        errorFound = true;
        break;
      }
    }
    return errorFound;
  }
  return false;
};

export const handleCheckErrorForNdcBulkEdit = ({
  ndcStrategyIndividualEditData,
  initialNdcStrategyIndividualEditData,
  setErrorDetails,
  userRoles,
  checkIfFunctionalityEnabled,
  futureNdcData,
  userModulesRoles,
}: {
  ndcStrategyIndividualEditData: NDCFormFields;
  initialNdcStrategyIndividualEditData: NDCFormFields;
  setErrorDetails: (error: { isError: boolean; errorDetails: string }) => void;
  userRoles: roleInstance[];
  checkIfFunctionalityEnabled: (
    a: roleInstance[],
    b: roleInstance[],
    userModulesRoles: { [key in moduleTypes]: roleInstance[] }
  ) => boolean;
  futureNdcData: ndcHistoryDataInterface;
  userModulesRoles: { [key in moduleTypes]: roleInstance[] };
}) => {
  if (ndcStrategyIndividualEditData && initialNdcStrategyIndividualEditData) {
    let errorFound = false;
    const fields: NDCFormFieldsTypes[] = ['PPS', 'PPSSC', 'Segmentation', 'DPStrategy'];

    if (
      ndcStrategyIndividualEditData.PPS.selected &&
      !checkIfFunctionalityEnabled(ndcAllowedRoles.ppsPpsStrategyEdit, userRoles, userModulesRoles)
    ) {
      errorFound = true;
      setErrorDetails({
        isError: true,
        errorDetails: `You do not have enough access to edit PPS`,
      });
      return errorFound;
    }
    if (
      ndcStrategyIndividualEditData.PPSSC.selected &&
      !checkIfFunctionalityEnabled(ndcAllowedRoles.ppsPpsStrategyEdit, userRoles, userModulesRoles)
    ) {
      errorFound = true;
      setErrorDetails({
        isError: true,
        errorDetails: `You do not have enough access to edit PPS Strategy`,
      });
      return errorFound;
    }
    if (
      ndcStrategyIndividualEditData.Segmentation.selected &&
      !checkIfFunctionalityEnabled(ndcAllowedRoles.segmentationEdit, userRoles, userModulesRoles)
    ) {
      errorFound = true;
      setErrorDetails({
        isError: true,
        errorDetails: `You do not have enough access to edit Segmenation`,
      });
      return errorFound;
    }
    if (
      ndcStrategyIndividualEditData.DPStrategy.selected &&
      !checkIfFunctionalityEnabled(ndcAllowedRoles.dpStrategyEdit, userRoles, userModulesRoles)
    ) {
      errorFound = true;
      setErrorDetails({
        isError: true,
        errorDetails: `You do not have enough access to edit DP Strategy`,
      });
      return errorFound;
    }
    // fields.forEach((field) => {
    for (let i = 0; i < fields.length; i++) {
      // check if something is left empty
      const field = fields[i];
      if (ndcStrategyIndividualEditData[field].selected) {
        if (
          !ndcStrategyIndividualEditData[field].value &&
          (ndcStrategyIndividualEditData[field].startDate ||
            ndcStrategyIndividualEditData[field].endDate)
        ) {
          setErrorDetails({
            isError: true,
            errorDetails: `Value, start and end date can't be left empty for ${
              field === 'PPSSC' ? 'PPS reason' : field
            }`,
          });
          errorFound = true;
          break;
        }

        if (!ndcStrategyIndividualEditData[field].value) {
          setErrorDetails({
            isError: true,
            errorDetails: `Please select value for ${field === 'PPSSC' ? 'PPS reason' : field}`,
          });
          errorFound = true;
          break;
        }

        if (
          ndcStrategyIndividualEditData[field].value &&
          !ndcStrategyIndividualEditData[field].startDate &&
          !ndcStrategyIndividualEditData[field].endDate
        ) {
          setErrorDetails({
            isError: true,
            errorDetails: `Start and end dates can't be left empty for ${
              field === 'PPSSC' ? 'PPS reason' : field
            } `,
          });
          errorFound = true;
          break;
        }

        if (
          ndcStrategyIndividualEditData[field].value &&
          !ndcStrategyIndividualEditData[field].startDate
        ) {
          setErrorDetails({
            isError: true,
            errorDetails: `Start date can't be left empty for ${
              field === 'PPSSC' ? 'PPS reason' : field
            } `,
          });
          errorFound = true;
          break;
        }

        if (
          ndcStrategyIndividualEditData[field].value &&
          !ndcStrategyIndividualEditData[field].endDate
        ) {
          setErrorDetails({
            isError: true,
            errorDetails: `End date can't be left empty for ${
              field === 'PPSSC' ? 'PPS reason' : field
            } `,
          });
          errorFound = true;
          break;
        }

        if (
          ndcStrategyIndividualEditData[field].startDate &&
          ndcStrategyIndividualEditData[field].endDate &&
          new Date(ndcStrategyIndividualEditData[field].startDate) >=
            new Date(ndcStrategyIndividualEditData[field].endDate)
        ) {
          setErrorDetails({
            isError: true,
            errorDetails: `Start should be lesser than End date for ${
              field === 'PPSSC' ? 'PPS reason' : field
            }`,
          });
          errorFound = true;
          break;
        }

        // check if the date range overlaps with future date ranges
        const tempDateRange: FutureNdcStrategyDates[] = [];

        if (field === 'PPS') {
          futureNdcData.PPS_History.future.forEach(instance => {
            tempDateRange.push({
              StartDate: instance.StartDate,
              EndDate: instance.EndDate,
              NDC11: instance.NDC11,
            });
          });
        } else if (field === 'PPSSC') {
          futureNdcData.PPS_Reason_History.future.forEach(instance => {
            tempDateRange.push({
              StartDate: instance.StartDate,
              EndDate: instance.EndDate,
              NDC11: instance.NDC11,
            });
          });
        } else if (field === 'Segmentation') {
          futureNdcData.Segmentation.future.forEach(instance => {
            tempDateRange.push({
              StartDate: instance.StartDate,
              EndDate: instance.EndDate,
              NDC11: instance.NDC11,
            });
          });
        } else if (field === 'DPStrategy') {
          futureNdcData.dp_strategy.future.forEach(instance => {
            tempDateRange.push({
              StartDate: instance.StartDate,
              EndDate: instance.EndDate,
              NDC11: instance.NDC11,
            });
          });
        }
        const overlapResponse = checkFutureStrategiesOverlapForNdcEdit(
          ndcStrategyIndividualEditData[field].startDate,
          ndcStrategyIndividualEditData[field].endDate,
          tempDateRange
        );
        if (overlapResponse.overlapFound) {
          setErrorDetails({
            isError: true,
            errorDetails: `${overlapResponse.error} for ${
              field === 'PPSSC' ? 'PPS reason' : field
            }, please navigate to individual edit modal to delete future strategies`,
          });
          errorFound = true;
          break;
        }
      }
    }
    return errorFound;
  }
  return false;
};

export const checkFutureStrategiesOverlapForNdcEdit = (
  startDate: string,
  endDate: string,
  dateRanges: FutureNdcStrategyDates[]
) => {
  const startDateInstance = new Date(startDate);
  const endDateInstance = new Date(endDate);
  const res: { overlapFound: boolean; error: string } = {
    overlapFound: false,
    error: '',
  };
  dateRanges.forEach(futureDate => {
    const tempStartDate = new Date(futureDate.StartDate);
    const tempEndDate = new Date(futureDate.EndDate);
    if (!(startDateInstance > tempEndDate || tempStartDate > endDateInstance)) {
      res.overlapFound = true;
      res.error = `NDC ${futureDate.NDC11} has future strategy which collides with current date range`;
    }
  });
  return res;
};
